/*
custom-stamp-text.js
Copyright 2021 Able Sense
*/

document.addEventListener('DOMContentLoaded', loaded);

function loaded() {
  var addToCartButton = document.getElementById('AddToCart');
  
  if (addToCartButton) {
    addToCartButton.disabled = true;
  }
  
  var customTextLineOneInput = document.getElementById('ct-lines__one');
  var customTextLineTwoInput = document.getElementById('ct-lines__two');
  var customTextLineThreeInput = document.getElementById('ct-lines__three');
  
  if (customTextLineOneInput) {
    customTextLineOneInput.addEventListener('keyup', function(ev) {
      if (customTextLineOneInput.value.length > 0) {
        addToCartButton.disabled = false;
        
        if (customTextLineOneInput.value.length > 28) {
          return;
        }
      }
      else {
        addToCartButton.disabled = true;
      }
    });
    
    customTextLineOneInput.addEventListener('blur', function(ev) {
      if (customTextLineOneInput.value.length > 0) {
        addToCartButton.disabled = false;
      }
      else {
        addToCartButton.disabled = true;
      }
    });
  }
  
  if (customTextLineTwoInput) {
    customTextLineTwoInput.addEventListener('keyup', function(ev) {
      if (customTextLineTwoInput.value.length > 28) {
        return;
      }
    })
  }
  
  if (customTextLineThreeInput) {
    customTextLineThreeInput.addEventListener('keyup', function(ev) {
      if (customTextLineThreeInput.value.length > 28) {
        return;
      }
    })
  }
}